import React from 'react';
import { Archive } from 'lucide-react';

/**
 * SnapshotBadge — kleine UX indicator op ingediende checklists.
 *
 * Toont een subtiele badge wanneer de template-staat is bevroren (snapshot
 * gemaakt bij submit, v17.4). Renders niets voor drafts of legacy invullingen
 * zonder snapshot.
 *
 * Props:
 * - template: response.template object met optioneel `_from_snapshot` flag
 *   en het invulling-doc met optioneel `template_snapshot.snapshot_genomen_op`
 * - snapshotDate: ISO datestring uit invulling.template_snapshot.snapshot_genomen_op
 *   (als beschikbaar — anders valt terug op invulling.ingevuld_op)
 */
const formatNL = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return '';
  }
};

export const SnapshotBadge = ({ template, snapshotDate, fallbackDate }) => {
  if (!template?._from_snapshot) return null;
  const dateStr = formatNL(snapshotDate || fallbackDate);
  return (
    <div
      className="inline-flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-1 text-xs text-slate-600 self-start"
      title="De template is na indienen gewijzigd. Dit is de originele versie zoals ingediend."
      data-testid="snapshot-badge"
    >
      <Archive className="w-3 h-3 text-[#1f2548]" />
      <span>
        Bevroren weergave
        {dateStr ? <> — template-staat op <span className="font-medium text-slate-700">{dateStr}</span></> : null}
      </span>
    </div>
  );
};

export default SnapshotBadge;
